import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'
import { patch } from "@rails/request.js"

// Connects to data-controller="sortable-list"
export default class extends Controller {
  static values = { url: String, group: String, pageId: String }

  connect() {
    Sortable.create(this.element, {
      onEnd: this.end.bind(this),
      animation: 150,
      group: {
        name: this.groupValue,
        pull: true,
        revertClone: true,
      }
    })
  }

  end(event) {
    const item = event.item
    const data = new FormData()

    if(event.newIndex === event.oldIndex && event.to === event.from) {
      return
    }

    data.append("section_id", item.dataset.id)
    data.append("position", event.oldIndex)
    data.append("new_position", event.newIndex)
    data.append("id", item.dataset.id)

    const oldPageId = event.from.dataset.sortableListPageIdValue
    const newPageId = event.to.dataset.sortableListPageIdValue
    data.append("old_page_id", oldPageId)
    data.append("new_page_id", newPageId)

    let url = this.urlValue

    if (event.to !== event.from) {
      url = event.to.dataset.sortableListUrlValue
    }

    patch(url, {
      body: data,
      // headers: {
      //   "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      // }
    }).then(response => {
      if(response.ok) {
        let previourBackgroundColor = item.style.backgroundColor
        item.style.backgroundColor = "lightgreen"
        item.style.transition = "background-color 1s"
        item.style.transitionTimingFunction = "ease"
        item.style.transitionDelay = "0s"
        item.style.transitionDuration = "1s"
        item.style.transitionProperty = "background-color"

        setTimeout(() => {
          item.style.backgroundColor = previourBackgroundColor
        }, 1000)
      }
    });
  }
}
